// extracted by mini-css-extract-plugin
export default {"portfolio":"portfolio_portfolio__8pN5E","container":"portfolio_container__MkHVz","title":"portfolio_title__9fMee","img":"portfolio_img__tRxDN"};